type TypeProps = {
  width?: string;
  height?: string;
  onClick?: () => void;
  color: string;
  className: string;
}

export const ArrowUp = ({ width, height, color, onClick, className }: TypeProps) => {
  return (
    <svg 
      onClick={onClick}
      className={className}
      width={width || "13"}
      height={height || "8"} 
      viewBox="0 0 13 8" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M6.36105 0.611206C6.55996 0.611206 6.75073 0.690224 6.89138 0.830876L12.1138 6.05326C12.4067 6.34615 12.4067 6.82102 12.1138 7.11392C11.8209 7.40681 11.346 7.40681 11.0531 7.11392L6.36105 2.42187L1.669 7.11392C1.37611 7.40681 0.901235 7.40681 0.608342 7.11392C0.315449 6.82102 0.315449 6.34615 0.608342 6.05326L5.83072 0.830876C5.97137 0.690224 6.16214 0.611206 6.36105 0.611206Z" fill={color}/>
    </svg>
  );
}